import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { loginSchema } from "../../services/validator";
import { toast } from "react-toastify";
import useToast from "../../helpers/useToast";
import {
  TextField,
  Button,
  Box,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import useEncryption from "../../services/useEncryption";
import { useDispatch } from "react-redux";
import { loginApi } from "../../api/authApi/authApi";
import {
  loginStart,
  loginSuccess,
  loginFailure,
} from "../../redux/slice/authSlice";
import sidebanner from "../../assets/images/authimgs/NVMGirl2.png";
import "./login.css";
import { createAuditLogs } from "../../api/providerApi/providerApi";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const toastOptions = useToast();
  const dispatch = useDispatch();
  const { encryptData, decryptData } = useEncryption();

  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = loginSchema;

  const onSubmit = async (values) => {
    dispatch(loginStart());

    try {
      const data = encryptData(values);
      const response = await loginApi(data);
      const decryptedData = decryptData(response.data.data);

      sessionStorage.setItem("token", decryptedData.token);
      sessionStorage.setItem("expiryTime", decryptedData.expiryTime);

      const encryptedId = encryptData(decryptedData.id);
      const id = encodeURIComponent(encryptedId);
      let obj = {
        event: `${
          decryptedData.role === "doctor"
            ? "Doctor"
            : decryptedData.role === "location"
            ? "Location"
            : "SuperAdmin"
        } login successfully.`,
        type: "login",
      };
      await createAuditLogs(
        { data: encryptData(obj) },
        {
          headers: {
            Authorization: `Bearer ${decryptedData.token}`,
            "Content-Type": "application/json",
          },
        }
      );

      dispatch(loginSuccess(decryptedData));
      toast.success(response.data.message, toastOptions);

      switch (decryptedData.role) {
        case "admin":
          navigate("/admin/dashboard");
          break;
        case "doctor":
          navigate(`/doctor/${id}`);
          break;
        case "staff":
          navigate(`/staff/${id}`);
          break;
        case "provider":
          navigate(`/provider/${id}`);
          break;
        case "location":
          navigate(`/location/${id}`);
          break;
        default:
          navigate("/");
          break;
      }
    } catch (error) {
      dispatch(loginFailure(error.response.data.message));
      toast.error(error.response.data.message, toastOptions);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <main className="authForms">
      <div className="row">
        <div className="col-lg-4 col-sm-12">
          <img className="bannerImg" src={sidebanner} alt="banner" />
        </div>
        <div className="col-lg-8 col-sm-12">
          <Box className="auth-page">
            <div className="authconatiner">
              <Box className="auth-form">
                <Typography variant="h4" gutterBottom align="center">
                  Hello Again! 👋
                </Typography>
                <p className="subTitle">Enter your email and password</p>
                <form onSubmit={formik.handleSubmit}>
                  <Box className="input-field-section">
                    <TextField
                      fullWidth
                      id="email"
                      name="email"
                      label="Email"
                      type="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.email && Boolean(formik.errors.email)
                      }
                      helperText={formik.touched.email && formik.errors.email}
                      autoComplete="off"
                      size="small"
                    />
                  </Box>
                  <Box className="input-field-section">
                    <TextField
                      fullWidth
                      id="password"
                      name="password"
                      label="Password"
                      autoComplete="off"
                      size="small"
                      type={showPassword ? "text" : "password"}
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.password &&
                        Boolean(formik.errors.password)
                      }
                      helperText={
                        formik.touched.password && formik.errors.password
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleTogglePasswordVisibility}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>

                  <Button
                    type="submit"
                    variant="contained"
                    className="btnMain"
                    fullWidth
                    sx={{ mt: 2 }}
                  >
                    Sign In
                  </Button>
                  <Box mt={2} display="flex" justifyContent="right">
                    <Link to="/forgot-password" className="sideLink">
                      Forgot Password?
                    </Link>
                  </Box>
                </form>
              </Box>
            </div>
          </Box>
        </div>
      </div>
    </main>
  );
};

export default Login;
